import {
    TprmCredentialType,
    TprmRequirementDefinition,
} from '@evidentid/tprm-portal-lib/models/common';
import { OpsProductUpdate, ProductUpdateInput } from '@evidentid/tprm-portal-lib/models/product-updates';

type RequestMethod = <T = any>(
    method: string,
    requestUrl: string,
    data?: any,
    allowedAdditionalHttpStatuses?: number[],
) => Promise<T>;

function getOpsUiUrl(path: string): string {
    return encodeURI(`/ops-ui${path}`);
}

export class OpsUiService {
    private readonly request: RequestMethod;

    public constructor(request: RequestMethod) {
        this.request = request;
    }

    public getEsigTemplates(commonName: string): Promise<any> {
        return this.request('GET', getOpsUiUrl(`/rps/${commonName}/docusign/templates`));
    }

    public saveEsigTemplates(commonName: string, templates: any): Promise<any> {
        return this.request('PUT', getOpsUiUrl(`/rps/${commonName}/docusign/templates`), templates);
    }

    public getTprmCustomPropertyTypes(): Promise<any> {
        return this.request('GET', getOpsUiUrl('/models/custom-property-types'));
    }

    public getTprmCredentialTypes(): Promise<TprmCredentialType[]> {
        return this.request('GET', getOpsUiUrl('/models/credentials'));
    }

    public getTprmRequirements(): Promise<TprmRequirementDefinition[]> {
        return this.request('GET', getOpsUiUrl('/models/requirements'));
    }

    public getProductUpdates(): Promise<OpsProductUpdate[]> {
        return this.request('GET', getOpsUiUrl('/product-updates'));
    }

    public createProductUpdate(input: ProductUpdateInput): Promise<OpsProductUpdate> {
        return this.request('POST', getOpsUiUrl('/product-updates'), input);
    }

    public updateProductUpdate(id: string, input: ProductUpdateInput): Promise<OpsProductUpdate> {
        return this.request('PATCH', getOpsUiUrl(`/product-updates/${id}`), input);
    }

    public publishProductUpdate(id: string): Promise<OpsProductUpdate> {
        return this.request('POST', getOpsUiUrl(`/product-updates/${id}/publish`));
    }

    public archiveProductUpdate(id: string): Promise<OpsProductUpdate> {
        return this.request('POST', getOpsUiUrl(`/product-updates/${id}/archive`));
    }
}
